import { Group, Skeleton, Stack } from '@mantine/core';

interface IChatMessageListSkeletonProps {
  size?: 'sm' | 'md';
}

export function ChatMessageListSkeleton({
  size = 'md',
}: IChatMessageListSkeletonProps) {
  const isNormalSize = size === 'md';
  const lineHeight = isNormalSize ? '3rem' : '2.2rem';

  return (
    <Stack gap={isNormalSize ? 'xs' : '0.5rem'} p="1rem">
      <Group>
        <Skeleton h={lineHeight} w={isNormalSize ? '10rem' : '8rem'} />
      </Group>

      <Group>
        <Skeleton h={lineHeight} w={isNormalSize ? '8rem' : '6rem'} />
      </Group>

      <Group justify="end">
        <Skeleton h={lineHeight} w={isNormalSize ? '12rem' : '10rem'} />
      </Group>

      <Group justify="end">
        <Skeleton
          h={`calc(2 * ${lineHeight})`}
          w={isNormalSize ? '20rem' : '18rem'}
        />
      </Group>

      <Group justify="end">
        <Skeleton h={lineHeight} w={isNormalSize ? '20rem' : '18rem'} />
      </Group>

      <Group>
        <Skeleton h={lineHeight} w={isNormalSize ? '8rem' : '6rem'} />
      </Group>

      <Group>
        <Skeleton h={lineHeight} w={isNormalSize ? '12rem' : '10rem'} />
      </Group>
    </Stack>
  );
}
